import React, { useEffect, useState } from 'react';
import './book.css';
import { Award, BookOpen, Calendar, Clock, Image, Map } from 'react-feather';
import backpic from './img/pic_3.jpeg';
import class1 from './img/class/1a.jpg';
import class2 from './img/class/2b.jpg';
import class3 from './img/class/3a.jpg';
import class4 from './img/class/4.jpg';
import class5 from './img/class/5.jpg';
import class6 from './img/class/6.jpg';
import logo from './img/edaplogo.png';

function Book() {
  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector('.navbar');
      const logo = document.querySelector('.logo');

      if (window.scrollY > 10) {
        navbar.classList.add('scrolled');
        logo.classList.add('hide-logo');
      } else {
        navbar.classList.remove('scrolled');
        logo.classList.remove('hide-logo');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  function Counter({ image, title }) {
    return (
      <div className="counter-wrapper">
        <div className="counter">
          <img src={image} alt={title} className="counter-image" />
          <div className="overlay">
            <span className="title">{title}</span>
          </div>
        </div>
        <div className="below-title">{title}</div>
      </div>
    );
  }

  const [expandedSection, setExpandedSection] = useState('primaire');

  const toggleSection = (section) => {
    setExpandedSection(expandedSection === section ? null : section);
  };

  const tabList = [
    { key: "maternelle", label: "Section Maternelle" },
    { key: "primaire", label: "Section Primaire" },
    { key: "secondaire", label: "Section Secondaire" }
  ];

  return (
    <div className="App">
        <div className="top-nav">
            <a href="/">
            <img src={logo} className="logo" style={{ width: '5%', position: 'fixed', top: 0, zIndex: 1 }} />
            </a>
            <nav className="navbar">
            <ul className="nav-links">
                <li><a href="/"><strong>EDAP-UNILIS</strong></a></li>
                <li style={{ marginLeft: "350px" }}><a href="#"><strong>Adacemics</strong></a></li>
                <li><a href="#home"><strong>Bibliotheque</strong></a></li>
                <li><a href="#home"><strong>Inscription</strong></a></li>
                <li><a href="#home"><strong>Staff</strong></a></li>
                <li><a href="#home"><strong>Contact</strong></a></li>
                <li><a href="login"><strong>Login</strong></a></li>
            </ul>
            </nav>
        </div>

        <div className='body-content'>
        <div className="class_section">
                <div className="tabs">
                    {tabList.map((tab) => (
                        <div
                            key={tab.key}
                            onClick={() => setExpandedSection(tab.key)}
                            className={`tab ${expandedSection === tab.key ? 'active' : ''}`}
                        >
                            {tab.label} {expandedSection === tab.key ? '▲' : '▼'}
                        </div>
                    ))}
                </div>

                <div className={`section-content ${expandedSection === "maternelle" ? 'expanded' : ''}`}>
                    {expandedSection === "maternelle" && (
                    <div className="counters">
                        <Counter image={backpic} title="1ère Maternelle" />
                        <Counter image={backpic} title="2ème Maternelle" />
                        <Counter image={backpic} title="3ème Maternelle" />
                    </div>
                    )}
                </div>

                <div className={`section-content ${expandedSection === "primaire" ? 'expanded' : ''}`}>
                    {expandedSection === "primaire" && (
                    <div className="counters">
                        <Counter image={class1} title="1ème année primaire" />
                        <Counter image={class2} title="2ème année primaire" />
                        <Counter image={class3} title="3ème année primaire" />
                        <Counter image={class4} title="4ème année primaire" />
                        <Counter image={class5} title="5ème année primaire" />
                        <Counter image={class6} title="6ème année primaire" />
                    </div>
                    )}
                </div>

                <div className={`section-content ${expandedSection === "secondaire" ? 'expanded' : ''}`}>
                    {expandedSection === "secondaire" && (
                    <div className="counters">
                        <Counter image={backpic} title="1ère Secondaire" />
                        <Counter image={backpic} title="2ème Secondaire" />
                        <Counter image={backpic} title="3ème Secondaire" />
                        <Counter image={backpic} title="4ème Secondaire" />
                        <Counter image={backpic} title="5ème Secondaire" />
                        <Counter image={backpic} title="6ème Secondaire" />
                    </div>
                    )}
                </div>
            </div>
            <div className='booklist'>
                <h3> <Calendar></Calendar> Horaire Academique</h3>
                <h4 style={{borderTop: "2px solid gray", marginBottom: "-10px"}}></h4>
                <h3> <Clock></Clock> Horaire des Classes</h3>
                <h4 style={{borderTop: "2px solid gray", marginBottom: "-10px"}}></h4>
                <h3> <Map></Map> Extra-scholaire</h3>
                <h4 style={{borderTop: "2px solid gray", marginBottom: "-10px"}}></h4>
                <h3> <BookOpen></BookOpen> Bibliotheque</h3>
                <h4 style={{borderTop: "2px solid gray", marginBottom: "-10px"}}></h4>
                <h3> <Image></Image> <a href='gallery'>Gallery</a></h3>
                {/* <h4 style={{borderTop: "2px solid gray", marginBottom: "-10px"}}></h4> */}
            </div>
        </div>
      <footer> EDAP-UNILIS © All Rights Reserved.</footer>
    </div>
  );
}

export default Book;
